<div class="line-container d-flex align-items-center mb-2">
  <span>{{ title | translate }}: &nbsp;</span>
  <span
    ><strong>{{ getNumberOfParticipantsPart$() | async }}</strong></span
  >

  <button
    class="btn btn-sm btn-ghost-primary ms-2"
    *ngIf="(getNumberOfParticipantsPart$() | async) >= 0"
    [hidden]="isAdjustFormVisible"
    (click)="showAdjustForm(type)"
    type="button"
  >
    <i
      role="img"
      class="fas fa-edit"
      attr.aria-label="{{ 'general.edit' | translate }}"
    ></i>
  </button>
</div>

<ng-container *ngIf="isAdjustFormVisible">
  <div
    *ngFor="
      let participantCount of participationCountsByResource;
      let i = index
    "
    class="align-items-center mb-2 row"
  >
    <div class="col-md-6 col-lg-4 col-xl-3 text-md-end">
      {{ participantCount.description }}:&nbsp;
      {{ participantCount.currentNumberOfParticipants }}
      <span class="text-muted text-sm"
        >({{ 'general.max' | translate }}:
        {{ getMaxParticipants$(participantCount) | async }})</span
      >
    </div>

    <div class="col-md-6 col-lg-5">
      <div class="row row-cols-md align-items-center">
        <div class="col-6 col-lg-4">
          <input
            #numberOfParticipants
            id="numberOfParticipants"
            (input)="sendTheNewValue($event, i)"
            type="number"
            [min]="0"
            [max]="participantCount.maxNumberOfParticipants"
            [ngModel]="participantCount.adjustedNumberOfParticipants"
            class="form-control"
            [disabled]="
              showAddMoreButton(
                getNumberOfParticipantsPart$() | async,
                participationCountsByResource,
                productEntities$ | async,
                bookingEntities$ | async,
                participation$ | async
              ) && !overWritePartcipants.get(type)
            "
          />
        </div>
        <div
          class="col-6"
          *ngIf="i == participationCountsByResource.length - 1"
        >
          <button
            type="button"
            class="btn btn-sm btn-soft-success"
            [disabled]="isParticipantCountChanged()"
            (click)="onAdjustNumberOfParticipants()"
          >
            <i
              role="img"
              class="fa fa-check fa-fw"
              attr.aria-label="{{ 'general.confirm' | translate }}"
            ></i>
          </button>

          <button
            type="button"
            class="btn btn-sm btn-soft-danger"
            (click)="closeInput(type)"
          >
            <i
              role="img"
              class="fas fa-times fa-fw"
              attr.aria-label="{{ 'general.cancel' | translate }}"
            ></i>
          </button>
        </div>
      </div>
    </div>
    <div class="row row-cols-md align-items-center">
      <form [formGroup]="formInvitedMembersMail" class="ps-5">
        <div class="mt-2" formArrayName="invitedMembersMail">
          <div
            class="mb-3 col-12 col-md-6"
            *ngFor="let _ of invitedMemberMail?.controls; index as idx"
          >
            <ng-container [formGroupName]="idx">
              <label class="form-label">
                {{ 'memberModule.member' | translate }}
                <span
                  *ngIf="
                    !invitedMembersFormGroupAt(idx).dirty &&
                    invitedMembersFormGroupAt(idx).invalid
                  "
                  class="small"
                >
                  ({{ 'general.isRequired' | translate }})
                </span>
              </label>
              <div class="d-flex gap-2">
                <member-select-input
                  (search)="onSearchMembers($event)"
                  [members]="members$ | async"
                  formControlName="email"
                  [allowClearing]="false"
                  class="w-100"
                  [attr.aria-invalid]="
                    invitedMembersFormGroupAt(idx).dirty &&
                    invitedMembersFormGroupAt(idx).invalid
                      ? 'true'
                      : null
                  "
                  [attr.aria-required]="
                    !invitedMembersFormGroupAt(idx).dirty &&
                    invitedMembersFormGroupAt(idx).invalid
                      ? 'true'
                      : 'false'
                  "
                ></member-select-input>

                <button
                  class="btn btn-icon btn-soft-primary rounded-pill me-2"
                  (click)="removeInvitedMemberMail(i, idx)"
                  type="button"
                >
                  <i
                    role="img"
                    class="fa fa-minus"
                    attr.aria-label="{{ 'wcag.removeByOne' | translate }}"
                  ></i>
                </button>
              </div>
              <p
                class="invalid-feedback mb-2"
                role="alert"
                aria-atomic="true"
                *ngIf="
                  invitedMembersFormGroupAt(idx).dirty &&
                  invitedMembersFormGroupAt(idx).invalid
                "
              >
                {{ 'general.email' | translate }}
                {{ 'general.invalid' | translate | lowercase }}
              </p>
            </ng-container>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div
    class="mb-4 mt-3"
    *ngIf="showCancellationPolciyField() || showCancellationPolciy"
  >
    <form [formGroup]="form">
      <label class="form-label">
        {{ 'saleModule.cancelationPolicy' | translate }}
      </label>

      <select
        formControlName="cancelationPolicyUuid"
        class="form-select"
        [attr.aria-invalid]="
          form.controls.cancelationPolicyUuid.dirty &&
          form.controls.cancelationPolicyUuid.invalid
            ? 'true'
            : null
        "
      >
        <option
          *ngFor="let cancellationPolicy of cancellationPolicies$ | async"
          [value]="cancellationPolicy.cancellationPolicyId"
        >
          {{
            cancellationPolicy[
              'title_' + ((selectedLanguage$ | async) || 'en')
            ] || cancellationPolicy['title_en']
          }}
        </option>
      </select>
    </form>
  </div>
</ng-container>
